module.exports = __webpack_public_path__ + "media/images/vacances-printemps-m-5ab3834411c672e3ebb6133ecd8101e7.jpg";